import React, { useEffect, useState } from 'react';
import { useDeviceType } from '../../../../CustomHooks/useDeviceType';
import { addDevice, deviceconfigcrud, getAllZoneList, updateDevice } from '../../../../services/configurationServices';
import { SuccessToast } from '../../../../CustomHooks/SuccessToast';
import { ErrorToast } from '../../../../CustomHooks/ErrorToast';
import Swal from "sweetalert2";
import { ConvertDateToUTC } from "../../../../utils/utils";

const FASDeviceForm = ({ 
    formData = {}, 
    onFormDataChange, 
    errors = {},
    isEditMode = false,
    onCancel,
    interfaceData,
    siteId,
    filterValues,

}) => {

    const { InterfaceIP='', UserName = '', Password = '', Interfacesubtypename = '', InterfacesubtypeId = '',
        Communicationport = '',  InterfaceId, isTwoWayEnabled = false,
        isHooterEnabled = false, InternetProtocolPort = '', TimeZoneID = 1, InterfacePort = '', ParentDeviceId = null
     } = interfaceData || {};

     const { ParentDeviceID = null, } = formData || {};

    const [deviceTypeOptions, setDeviceTypeOptions] = useState([]);
    const [zoneOptions, setZoneOptions] = useState([]);
    const [editAssociate, setEditAssociate] = useState(false);
    const [cameraSearch, setCameraSearch] = useState("");
    const [acsList, setAcsList] = useState([]);
      const [acsMasterList, setAcsMasterList] = useState([]);
      const [cameraSelectAll, setCameraSelectAll] = useState(false);
      const [cctvMasterList, setCCTVMasterList] = useState([]);
      const [cctvList, setCCTVList] = useState([]);
      const [alertsChecked, setAlertChecked] = useState(formData.AlertMonitoring || false);
      const [healthMonitoringChecked, setHealthMonitoringChecked] = useState(formData.HMMonitoring || false); 

    const { ClientId, DeviceId } = formData || {};

    const interfacetypename = "Fire Panel";

    const handleInputChange = (field, value) => {
        // Clear validation error for the field being changed
        const updatedFormData = { ...formData, [field]: value };
        
        // If errors exist, remove the error for this specific field
        if (formData.errors && formData.errors[field]) {
            const updatedErrors = { ...formData.errors };
            delete updatedErrors[field];
            updatedFormData.errors = updatedErrors;
        }
        
        // For ZoneID field, trigger validation immediately to show error if empty value is selected
        if (field === 'ZoneID' && (!value || value === "" || value === "0")) {
            const currentErrors = updatedFormData.errors || {};
            currentErrors.ZoneID = "Zone is required";
            updatedFormData.errors = currentErrors;
        }
        
        if (onFormDataChange) {
            onFormDataChange(updatedFormData);
        }
    };

    const { deviceType, panelDeviceTypeOptions, getDataAfterInterface } = useDeviceType();

    useEffect(() => {
        getDataAfterInterface(InterfaceId);
      }, [InterfaceId]);

      console.log({deviceType, interfaceData})

    useEffect(() => {
        let fasDevices = deviceType.filter(
            (dt) => dt.Interfacetypename === interfacetypename
        );
        // if (ParentDeviceID) {
        //     fasDevices = fasDevices.filter((dt) => dt.DeviceType !== "Fire Panel");
        // } else {
        //     fasDevices = fasDevices.filter(
        //         (dt) => dt.DeviceType === "Fire Panel"
        //     );
        // }
         if(isEditMode){
          if(ParentDeviceID){
            fasDevices = fasDevices.filter((dt) => dt.DeviceType !== "Fire Panel")
          }
          else{
            fasDevices = fasDevices.filter((dt) => dt.DeviceType === "Fire Panel")
          }
        }
        else{
          if(ParentDeviceId){
            fasDevices = fasDevices.filter((dt) => dt.DeviceType !== "Fire Panel")
          }
          else{
            fasDevices = fasDevices.filter((dt) => dt.DeviceType === "Fire Panel")
          }
        }

            const deviceTypeOptions = fasDevices.map((item) => ({
                value: item.DeviceTypeID,
                label: item.DeviceType,
            }));
            setDeviceTypeOptions(deviceTypeOptions);

            console.log({deviceTypeOptions})

            
            formData.Communicationport = Communicationport || "";
            formData.InterfacePort = InterfacePort || "";
        
    }, [deviceType]);

    console.log({deviceTypeOptions})

    useEffect(() => {
        const fetchZones = async () => {
            if (isEditMode) {
                getAssociateACSList();
            }

            const siteId = filterValues?.Site?.[0]?.value || null;
            const customerId = filterValues?.Customer?.[0]?.value || null;

            if (siteId && customerId) {
                try {
                    const response = await getAllZoneList({CustomerID: customerId, SiteID: siteId });
                    console.log('Zone API Response:', response);
                    
                    if (response && response.Status === 'success' && response.Data) {
                        const zoneOptions = response.Data.map((zone) => ({
                            value: zone.ZoneID,
                            label: zone.ZoneName,
                        }));
                        setZoneOptions(zoneOptions);
                        console.log('Zone Options:', zoneOptions);
                    } else {
                        setZoneOptions([]);
                    }
                } catch (error) {
                    console.error('Error fetching zones:', error);
                    setZoneOptions([]);
                }
            }
        };

        fetchZones();
    }, [isEditMode, filterValues]);

    const getAssociateACSList = () => {
        var obj = {
          action: "getAssociatedCamerasList",
          deviceId: DeviceId,
          userUniqueId: localStorage.getItem("UserID"),
          clientId: ClientId,
          siteId: siteId
          //siteId: parseInt(formData.ZoneID) || "",
        };
        deviceconfigcrud(obj).then((res) => {
          if (res.status == "Ok" || (res && res.Status === "success")) {
            let isAllSelected = true;
            let custTemp = res.Data.map((item, index) => {
              let obj;
              if (item.isSelected == false) {
                isAllSelected = false;
                obj = {
                  ...item,
                  isChecked: false,
                };
              } else {
                obj = {
                  ...item,
                  isChecked: true,
                };
              }
              return obj;
            });
            setAcsList(custTemp);
            setAcsMasterList(custTemp);
            //setCameraCount(custTemp.length);
            if (isAllSelected) {
              setCameraSelectAll(true);
            } else {
              setCameraSelectAll(false);
            }
          }
        });
      };
    
      const cancelACSAssociation = () => {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to cancel the changes made?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#027aaa",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
        }).then((result) => {
          if (result.isConfirmed) {
            setCameraSearch("");
            setEditAssociate(false);
            getAssociateACSList();
          }
        });
      };
    
      const customerCheckHandler = (e, id) => {
        let arr = acsList.map((item) => {
          let obj;
          if (item.deviceId == id) {
            obj = {
              ...item,
              isChecked: !item.isChecked,
            };
          } else {
            obj = {
              ...item,
            };
          }
          return obj;
        });
    
        let masterCustomer = acsMasterList.map((item) => {
          let obj;
          if (item.deviceId == id) {
            obj = {
              ...item,
              isChecked: !item.isChecked,
            };
          } else {
            obj = {
              ...item,
            };
          }
          return obj;
        });
    
        let customerArr = arr
          .filter((item) => item.isChecked)
          .map((i) => i.deviceId);
        let clientIds = customerArr.join(",");
        setAcsMasterList(masterCustomer);
        setAcsList(arr);
      };

      const searchCameraHandler = (e, type) => {
        let searchText = e.target.value;
        if (type == "Camera") {
          setCameraSearch(searchText);
          let arr = acsMasterList.filter((item) =>
            item.cameraName.toLowerCase().includes(searchText.toLowerCase())
          );
          let isChecked = true;
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].isChecked == true) {
              continue;
            } else {
              isChecked = false;
              break;
            }
          }
          setCameraSelectAll(isChecked);
          setAcsList(arr);
          //setCameraCount(arr.length);
        }
      };
    
    
      const associatetoACS = () => {
        var createdtime = ConvertDateToUTC(new Date());
        let userid = localStorage.getItem("UserID");
        let selectedItems = acsMasterList
          .filter((j) => j.isChecked)
          .map((i) => i.deviceId);
        if (selectedItems.length > 4) {
          ErrorToast(
            `Maximum only 4 cameras can be associated, you have associated ${selectedItems.length} cameras`
          );
          return;
        }
        // var obj = {
        //   "action": "associateCamerasToACS",
        //   "associatedCameraIds": selectedItems,
        //   "deviceId": selectedDevice.ParentCameraID,
        //   "createdBy": userid,
        //   "createdOn": createdtime,
        //   "userUniqueId": null,
        // }
        var obj = {
          action: "associateCamerasToSensor",
          associatedCameraIds: selectedItems,
          deviceId: DeviceId,
          createdBy: userid,
          createdOn: createdtime,
          userUniqueId: null,
        };
        deviceconfigcrud(obj).then((resp) => {
          if (
            (resp && resp.status === "Ok") ||
            (resp && resp.Status === "success")
          ) {
            SuccessToast(resp.Message);
            setEditAssociate(false);
          } else {
            // setEditAssociate(true);
            //console.log("respAssociate",resp)
            ErrorToast("Error occurred while associating the device!");
          }
        });
      };

    const validateForm = () => {
        const newErrors = {};

        // Device Name validation
        if (!formData.DeviceName || formData.DeviceName.trim() === "") {
            newErrors.DeviceName = "Device Name is required";
        }

        // Device Type validation
        if (!formData.DeviceTypeID || formData.DeviceTypeID === "") {
            newErrors.DeviceTypeID = "Device Type is required";
        }

        // Identifier Name validation
        if (!formData.ExternalId || formData.ExternalId.trim() === "") {
            newErrors.ExternalId = "Identifier Name is required";
        }

        // Zone validation - check for empty string, null, undefined, or "0"
        if (!formData.ZoneID || formData.ZoneID === "" || formData.ZoneID === "0") {
            newErrors.ZoneID = "Zone is required";
        }

        // if (!formData.serialNumber || formData.serialNumber.trim() === "") {
        //     newErrors.serialNumber = "Serial Number is required";
        // }

        return newErrors;
    };

    const handleSave = async () => {
        // Validate form before saving
        const validationErrors = validateForm();
        
        if (Object.keys(validationErrors).length > 0) {
            // Update error state to show validation messages
            if (onFormDataChange) {
                onFormDataChange({ ...formData, errors: validationErrors });
            }
            
            // Show error toast with first validation error
            const firstError = Object.values(validationErrors)[0];
            ErrorToast(firstError);
            return;
        }

        // Clear any previous errors
        if (onFormDataChange) {
            onFormDataChange({ ...formData, errors: {} });
        }
        const userId = JSON.parse(localStorage.getItem("user"))?.Id || "";
        const OrganizationMasterID =
          JSON.parse(localStorage.getItem("user"))?.OrganizationMasterID || "";
    
        console.log({ formData });
    
        const payload = {
          ParentDeviceID: isEditMode ? ParentDeviceID : ParentDeviceId,
          ExternalId: formData.ExternalId || "",
          Description: "",
          Metadata: "",
          DeviceTypeID: formData.DeviceTypeID || "",
          Lat: 0,
          Long: 0,
          Altitude: 0,
          SiteId: parseInt(formData.ZoneID) || "",
          InterfaceId: InterfaceId,
          Name: formData.DeviceName?.toString().trim() || "",
          InternetProtocolPort: InternetProtocolPort,
          isTwoWayEnabled: isTwoWayEnabled ? 1 : 0,
          alarmpanelHooterEnabledFlag: false,
          Communicationport: Communicationport,
          OrganizationMasterID: OrganizationMasterID,
          TimeZoneID: TimeZoneID,
          CreatedOn: "",
          ModifiedON: "",
          CreatedBy: userId,
          ModifiedBy: isEditMode ? userId : "",
          UpdatedateTime: "",
          CameraId: isEditMode && DeviceId ? DeviceId : 0,
          CameraGuid: "",
          IsPtz: 0,
          CameraIp: InterfaceIP || "",
          CameraPort: InterfacePort || "",
          CamUser: UserName || "",
          CamPassword: Password || "",
          CCTVTypeID: formData.DeviceTypeID || "",
          cctvHooterEnabledFlag: true,
          PlayBackChannelNum: 1,
          IsPlayBackTranscodingEnabled: 0,
          IsTranscodingEnabled: 0,
          SubTypeLive: 0,
          SubTypePlayback: 0,
          ISPlaybackUTC: 0,
          HLSStreamingURL: null,
          MonitoringService: 0,
          HMService: healthMonitoringChecked ? 1 : 0,
          AlertService: alertsChecked ? 1 : 0,
          RecordingBackupService: 0,
          SerialNo: formData.SerialNo?.toString().trim() || "",
          UserID: userId
        };

        // Add DeviceId for update operations
        if (isEditMode && DeviceId) {
            payload.DeviceId = DeviceId;
        }
    
        try {
            let resp;
            if (isEditMode) {
                resp = await updateDevice(payload);
            } else {
                resp = await addDevice(payload);
            }
            
            if (resp && resp.Status === "success") {
                SuccessToast(
                    isEditMode ? "Device updated successfully" : "Device added successfully"
                );
                // Close the form after successful save
                if (onCancel) {
                    onCancel();
                }
            } else {
                // Handle error
                ErrorToast(
                    resp?.Message || 
                    (isEditMode ? "Failed to update device" : "Failed to add device")
                );
            }
        } catch (error) {
            console.error("Error saving device:", error);
            ErrorToast(
                `An error occurred while ${isEditMode ? "updating" : "saving"} the device`
            );
        }
      };
      console.log({ formData, deviceTypeOptions });

    return (
        <>
        <div className="site-form">
            <h6 className="form-section-title">FAS Device Configuration</h6>
        </div>
        <div className='DeviceFormScroll'>
          <div className="site-form">
            <div className="inputMainContainer w40dot75rem">
                <div className="inputTypeLabelContainer">
                    <label className="formFieldLabels">Brand Name</label>
                    <select
                        className="inputType ArrowSelectClass"
                        value={formData.brandName || ''}
                        onChange={(e) => handleInputChange('brandName', e.target.value)}
                        disabled
                    >
                       <option value={InterfacesubtypeId}>{Interfacesubtypename}</option>
                    </select>
                    {errors.brandName && <p className="Error_P"><span>{errors.brandName}</span></p>}
                </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>IP Address</label>
                    <input
                        className="inputType"
                        value={InterfaceIP || ''}
                        onChange={(e) => handleInputChange('ipAddress', e.target.value)}
                        disabled
                        placeholder="IP address* e.g. 192.168.2.50"
                    />
                    {errors.ipAddress && <p className="Error_P"><span>{errors.ipAddress}</span></p>}
                </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Port</label>
                    <input
                        className="inputType"
                        value={InterfacePort || ''}
                        onChange={(e) => handleInputChange('InterfacePort', e.target.value)}
                        placeholder="Enter Port* e.g. 4001"
                        disabled
                    />
                    {errors.port && <p className="Error_P"><span>{errors.port}</span></p>}
                </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Interface Username</label>
                    <input
                        className="inputType"
                        value={UserName || ''}
                        onChange={(e) => handleInputChange('interfaceUsername', e.target.value)}
                        placeholder="Enter Interface Username*"
                        disabled
                    />
                    {errors.interfaceUsername && <p className="Error_P"><span>{errors.interfaceUsername}</span></p>}
                </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Interface Password</label>
                    <input
                        className="inputType"
                        type="password"
                        value={Password || ''}
                        onChange={(e) => handleInputChange('interfacePassword', e.target.value)}
                        placeholder="Enter Interface Password*"
                        disabled
                    />
                    {errors.interfacePassword && <p className="Error_P"><span>{errors.interfacePassword}</span></p>}
                </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Device Name*</label>
                    <input
                        className="inputType"
                        value={
                            isEditMode
                                ? formData.DeviceName || ""
                                : formData.DeviceName || ""
                        }
                        onChange={(e) => handleInputChange('DeviceName', e.target.value)}
                        placeholder="Enter Device Name* e.g. Main Fire Panel"
                    />
                    {(errors.DeviceName || formData.errors?.DeviceName) && (
                        <p className="Error_P" style={{ float: "left" }}>
                            <span>{errors.DeviceName || formData.errors?.DeviceName}</span>
                        </p>
                    )}
                </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Device Type*</label>
                    <select
                        className="inputType ArrowSelectClass"
                        value={formData.DeviceTypeID || ""}
                        onChange={(e) => handleInputChange('DeviceTypeID', e.target.value)}
                        // disabled = {formData.DeviceType === 'Fire Panel' ? true : false}
                    >
                        <option value="">Select Device Type*</option>
                        {deviceTypeOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {(errors.DeviceTypeID || formData.errors?.DeviceTypeID) && (
                        <p className="Error_P" style={{ float: "left" }}><span> {errors.DeviceTypeID || formData.errors?.DeviceTypeID} </span></p>
                    )}
                </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Identifier Name*</label>
                    <input
                        className="inputType"
                        value={
                            isEditMode
                                ? formData.ExternalId || ""
                                : formData.ExternalId || ""
                        }
                        onChange={(e) => handleInputChange('ExternalId', e.target.value)}
                        placeholder="Enter Identifier Name* e.g. MainFAS_Panel01"
                    />
                    {(errors.ExternalId || formData.errors?.ExternalId) && (
                        <p className="Error_P" style={{ float: "left" }}><span> {errors.ExternalId || formData.errors?.ExternalId} </span></p>
                    )}
                </div>
            </div>

            <div className="inputMainContainer w40dot75rem mt35">
                <div className="inputTypeLabelContainer">
                    <label className='formFieldLabels'>Zone*</label>
                    <select
                        className="inputType ArrowSelectClass"
                        value={formData.ZoneID || ""}
                        onChange={(e) => handleInputChange('ZoneID', e.target.value)}
                    >
                        <option value="">Select Zone*</option>
                        {zoneOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    {(errors.ZoneID || formData.errors?.ZoneID) && (
                        <p className="Error_P" style={{ float: "left" }}><span> {errors.ZoneID || formData.errors?.ZoneID} </span></p>
                    )}
                </div>
            </div>

             <div className="inputMainContainer w40dot75rem mt35">
                        <div className="inputTypeLabelContainer">
                          <label className='formFieldLabels'>Serial No</label>
                          <input
                            className="inputType"
                            placeholder="Enter Serial No e.g. MH78UY"
                           value={
                            isEditMode?
                            formData.SerialNo || ""
                            : formData.SerialNo || ""
                           }
                            onChange={(e) => handleInputChange('SerialNo', e.target.value)}
                          />
                          {/* {(errors.serialNumber || formData.errors?.serialNumber) && (<p className="Error_P" style={{ float: "left" }}><span>{errors.serialNumber || formData.errors?.serialNumber}</span></p>)} */}
                        </div>
                      </div>

            {isEditMode && formData.DeviceType == "Fire Panel" && (
                <div className="inputMainContainer w40dot75rem mt35">
                    <div className="inputTypeLabelContainer">
                        <label className="formFieldLabels">License Module</label>
                        <div className="mt-1 signTypeCheckboxLabels">
                            <div className="SiteTextBox mt-0">
                                <div className="onlyforEnableCheckbox ml-0">
                                    <input
                                        type="checkbox"
                                        className="checkbox_custom"
                                        id="exampleCheck1"
                                        checked={alertsChecked}
                                        onChange={() => setAlertChecked(!alertsChecked)}
                                    />
                                    <label className="" htmlFor="exampleCheck1">
                                        Alerts
                                    </label>
                                </div>
                            </div>
                            <div className="SiteTextBox mt-0">
                                <div className="onlyforEnableCheckbox ml-0">
                                    <input
                                        type="checkbox"
                                        className="checkbox_custom"
                                        id="exampleCheck2"
                                        checked={healthMonitoringChecked}
                                        onChange={() =>
                                            setHealthMonitoringChecked(!healthMonitoringChecked)
                                        }
                                    />
                                    <label className="" htmlFor="exampleCheck2">
                                        Health Monitoring
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isEditMode && (
            <>
              <div className="ACSCustomerFilterMainDiv w40dot75rem mt35">
                <div className="ACSTextBox mt-0">
                  <p
                    className="SiteNameText mb-0"
                    style={{ fontSize: "1.2rem" }}
                  >
                    Associate Device
                  </p>
                  <div className="filterinnerboxdiv1">
                    <div>
                      <div className="SelectionListWithSelectAll">
                        <input
                          className="SearchViewInput1"
                          style={{ width: "100%" }}
                          type="search"
                          placeholder="Search"
                          value={cameraSearch}
                          onChange={(e) => searchCameraHandler(e, "Camera")}
                        />
                      </div>
                    </div>
                    <div
                      className="HgtFilterBoxList"
                      style={{
                        textAlign: "left",
                        marginLeft: "5px",
                        height: "17vh",
                      }}
                    >
                      {acsList.length > 0 ? (
                        acsList.map((item) => (
                          <div
                            key={item.deviceId}
                            className="dataAccessListItem"
                          >
                            <input
                              type="checkbox"
                              checked={item.isChecked}
                              disabled={!editAssociate}
                              onChange={(e) =>
                                customerCheckHandler(e, item.deviceId)
                              }
                            />
                            <p
                              className="AllTextwithValue"
                              disabled={!editAssociate}
                              onClick={(e) => {
                                if (editAssociate) {
                                  customerCheckHandler(e, item.deviceId);
                                }
                              }}
                            >
                              {item.cameraName}
                            </p>
                          </div>
                        ))
                      ) : (
                        <p className="AllTextwithValue">No Cameras Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ alignItems: "center" }}>
                {!editAssociate ? (
                  <button
                    className="DataAccessEdit"
                    style={{ width: "170px" }}
                    onClick={() => setEditAssociate(true)}
                  >
                    <span className="ViewUpdate">Edit Associated Devices</span>
                  </button>
                ) : (
                  <>
                    <button
                      className="DataAccessEdit"
                      style={{ width: "180px" }}
                      onClick={() => associatetoACS()}
                    >
                      <span className="ViewUpdate">
                        Save Associated Devices
                      </span>
                    </button>
                    <button
                      className="DataAccessEdit"
                      style={{ width: "190px" }}
                      onClick={cancelACSAssociation}
                    >
                      <span className="ViewUpdate">
                        Cancel Associated Devices
                      </span>
                    </button>
                  </>
                )}
              </div>
            </>
          )}
            </div>
            </div>

            <div style={{ textAlign: "center", marginTop: "30px" }}>
                <button className="DataAccessEdit" style={{ width: "100px" }} onClick={handleSave}>
                    <span className="ViewUpdate">Save</span>
                </button>
                <button className="DataAccessEdit" style={{ width: "100px", marginLeft: "10px" }} onClick={onCancel}>
                    <span className="ViewUpdate">Cancel</span>
                </button>
            </div>
        </>
    );
};

export default FASDeviceForm;
